import { stripHtmlTags } from './utils.js';
import { updateRatingsFromCookies } from './set-post-total-rating.js';


const loadMoreButton = document.querySelector('#load-more-button');

// Проверяем, существует ли кнопка и добавляем обработчик события, если да.
if (loadMoreButton) {
  loadMoreButton.addEventListener('click', (event) => onLoadMoreButtonClick(event));
}

/**
 * Обработчик события при клике на кнопку загрузки дополнительных новостей.
 * @param {Event} event - Объект события клика.
 */
async function onLoadMoreButtonClick(event) {
  event.preventDefault(); // Предотвращаем стандартное поведение кнопки.

  // Получаем элементы и данные из DOM и атрибутов.
  const feedBlockList = document.querySelector('.feed-block__list');

  // Извлекаем значения из атрибутов кнопки.
  const currentPage = parseInt(loadMoreButton.dataset.currentPage, 10);
  const postsPerPage = parseInt(loadMoreButton.dataset.postsPerPage, 10);
  const categoryName = loadMoreButton.dataset.category;
  const exclude = JSON.parse(loadMoreButton.dataset.exclude);
  const cleanCategoryName = stripHtmlTags(categoryName); // Убираем HTML-теги из имени категории.
  const maxPages = loadMoreButton.dataset.maxPages;

  // Проверка валидности значений.
  if (isNaN(currentPage) || currentPage < 1) {
    throw new Error('Invalid page number'); // Ошибка, если номер страницы недействителен.
  }

  if (isNaN(postsPerPage) || postsPerPage < 1) {
    throw new Error('Invalid posts per page number'); // Ошибка, если количество записей некорректно.
  }

  if (typeof cleanCategoryName !== 'string') {
    throw new Error('Invalid category name'); // Ошибка, если имя категории недействительно.
  }

  // Создаем объект с параметрами для запроса.
  const args = {
    'post_type': 'news',
    'posts_per_page': postsPerPage,
    'paged': currentPage,
    'orderby': 'date',
    'order': 'DESC',
    'post__not_in': exclude, // Исключаем определенные записи.
  };

  if (cleanCategoryName && cleanCategoryName !== 'all') {
    args['tax_query'] = [
      {
        taxonomy: 'news_category',
        field: 'slug',
        terms: cleanCategoryName,
      },
    ];
  }

  // Выполняем запрос на получение дополнительных новостей.
  const response = await getMoreNews(args, maxPages);

  // Добавляем новый HTML-контент в список.
  feedBlockList.innerHTML += response.html;
  loadMoreButton.dataset.currentPage = currentPage + 1; // Обновляем текущую страницу.

  // Удаляем кнопку, если достигнута последняя страница.
  if (response.is_last_page) {
    loadMoreButton.remove();
  }

  updateRatingsFromCookies();
}

/**
 * Запрашивает дополнительные новости с сервера.
 * @param {Object} args - Объект с параметрами запроса.
 * @param {number} maxPages - Максимальное количество страниц.
 * @returns {Promise<Object>} - Объект с данными ответа.
 */
async function getMoreNews(args, maxPages) {
  const data = new FormData();

  // Устанавливаем параметры запроса.
  data.set('action', 'get_more_news');
  data.set('args', JSON.stringify(args));
  data.set('max_pages', maxPages);

  // Отправляем POST-запрос на сервер.
  return fetch('/wp-admin/admin-ajax.php', {
    method: 'POST',
    body: data,
  })
    .then(response => {
      // Проверка на успешность ответа.
      if (!response.ok) {
        throw new Error(`${response.status} - ${response.statusText}`);
      } else if (response.status === 204) {
        throw new Error('No content'); // Обработка ответа без содержания.
      }

      return response.json(); // Парсим JSON.
    })
    .then(data => {
      if (data.success) {
        return data.data; // Возвращаем данные при успехе.
      }

      console.error('Error fetching news'); // Логируем ошибку при неуспехе.
    })
    .catch(error => {
      console.error('Error fetching news', error); // Логируем ошибку при запросе.
    });
}
